"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.DefaultTextBlock = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.BaseTitle = styled_components_1.default.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-style: normal;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-feature-settings: 'cpsp' on, 'liga' off;\n  margin: 0;\n"], ["\n  color: ", ";\n  font-style: normal;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-feature-settings: 'cpsp' on, 'liga' off;\n  margin: 0;\n"])), function (props) {
  return props.theme.color.primary.v600;
});
exports.BaseSmallTitle = styled_components_1.default.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-style: normal;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-feature-settings: 'cpsp' on, 'liga' off;\n  margin: 0;\n"], ["\n  color: ", ";\n  font-style: normal;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-feature-settings: 'cpsp' on, 'liga' off;\n  margin: 0;\n"])), function (props) {
  return props.theme.color.primary.v600;
});
exports.BaseDescription = styled_components_1.default.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-feature-settings: 'liga' off;\n  margin: 0;\n"], ["\n  color: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-feature-settings: 'liga' off;\n  margin: 0;\n"])), function (props) {
  return props.theme.color.neutral.v500;
});
exports.BaseLink = styled_components_1.default.a(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-style: normal;\n  font-weight: normal;\n  color: ", " !important;\n  text-decoration-line: underline !important;\n  font-feature-settings: 'liga' off;\n  margin: 0;\n  ", "\n"], ["\n  font-style: normal;\n  font-weight: normal;\n  color: ", " !important;\n  text-decoration-line: underline !important;\n  font-feature-settings: 'liga' off;\n  margin: 0;\n  ", "\n"])), function (props) {
  return props.theme.color.primary.v200;
}, function (props) {
  return props.theme.font.body.v200;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;